document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-al-sort]').forEach(select => select.addEventListener('change', () => select.form.requestSubmit()));
  document.querySelectorAll('.accordion__tab').forEach(button => {
    const panel = button.closest('.accordion-wrapper')?.querySelector('.accordion__panel');
    if(!panel) return;
    const toggle = expanded => {
      button.setAttribute('aria-expanded', String(expanded));
      panel.hidden = !expanded;
      panel.style.display = expanded ? 'block' : 'none';
      button.closest('.accordion-wrapper').classList.toggle('active', expanded);
    };
    toggle(false);
    button.addEventListener('click', () => toggle(button.getAttribute('aria-expanded') !== 'true'));
  });
  const cartDrawer = (() => {
    const cartLink = document.getElementById('cart-icon-bubble');
    const cartCount = cartLink?.querySelector('.cart-count-bubble');
    const countText = cartCount?.querySelector('span');
    const syncCount = () => {
      const count = Number(countText?.textContent);
      if (!cartCount || !Number.isInteger(count) || count < 0) return;
      cartCount.hidden = count === 0;
      cartLink.setAttribute('aria-label', count === 0 ? 'Cart' : 'Cart, ' + count + (count === 1 ? ' item' : ' items'));
    };
    if (cartCount && countText) {
      new MutationObserver(syncCount).observe(countText, {childList: true, characterData: true, subtree: true});
      syncCount();
    }
    const open = () => {
      if(window.essentialCartApi?.openCart) window.essentialCartApi.openCart();
      else window.location.assign(window.routes.cart_url);
    };
    cartLink?.addEventListener('click', event => {
      if(event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !window.essentialCartApi?.openCart) return;
      event.preventDefault();
      open();
    });
    return {
      add: async form => {
        const response = await fetch(window.routes.cart_add_url + '.js', {
          method: 'POST', credentials: 'same-origin',
          body: new FormData(form), headers: {Accept: 'application/json'}
        });
        const result = await response.json();
        if(!response.ok) throw new Error(typeof result.description === 'string' ? result.description : (result.message || window.cartStrings?.error || 'Unable to add this item. Please try again.'));
        open();
      }
    };
  })();
  const bindAddForm = (form, main, afterSubmit) => {
    if(!cartDrawer) return;
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const button = event.submitter || form.querySelector('button[type="submit"]');
      if(button?.disabled || form.getAttribute('aria-busy') === 'true' || !form.querySelector('[name="id"]')?.value) return;
      const error = form.querySelector('.al-product-error') || main.querySelector('.al-product-error') || document.createElement('p');
      error.className = 'al-product-error';
      error.setAttribute('role','alert');
      error.textContent = '';
      form.setAttribute('aria-busy', 'true');
      if(button) button.disabled = true;
      try { await cartDrawer.add(form, button); }
      catch(failure) {
        error.textContent = failure.message;
        if(!error.isConnected) form.append(error);
      } finally {
        form.removeAttribute('aria-busy');
        if(button) button.disabled = false;
        afterSubmit?.();
      }
    });
  };
  const money = value => new Intl.NumberFormat('en-US', {style:'currency', currency:'USD'}).format(value / 100) + ' USD';
  document.querySelectorAll('[data-al-product]').forEach(element => {
    const product = JSON.parse(element.textContent);
    const main = element.closest('#MainContent') || document;
    const picker = main.querySelector('[data-al-picker]');
    const forms = [...main.querySelectorAll('[data-al-product-form]')];
    const select = () => {
      const options = picker ? [...picker.querySelectorAll('fieldset')].map(field => field.querySelector('input:checked')?.value).filter(Boolean) : [];
      const variant = product.variants.find(v => options.every((option, index) => option === v.options[index])) || product.variants[0];
      forms.forEach(form => {
        const input = form.querySelector('[name="id"]');
        if(input) input.value = variant.id;
        form.querySelectorAll('button[type="submit"]').forEach(button => {
          button.disabled = !variant.available || form.getAttribute('aria-busy') === 'true';
          const span = button.querySelector('span');
          if(span) span.textContent = variant.available ? window.variantStrings.addToCart : window.variantStrings.soldOut;
        });
      });
      const price = main.querySelector('product-info .price');
      if(price) {
        const discounted = variant.compare_at_price > variant.price;
        price.classList.toggle('price--on-sale', discounted);
        price.querySelectorAll('.price__regular .price-item--regular').forEach(el => el.textContent = money(variant.price));
        price.querySelectorAll('.price-item--sale').forEach(el => el.textContent = money(variant.price));
        price.querySelectorAll('.price__sale .price-item--regular').forEach(el => el.textContent = variant.compare_at_price ? money(variant.compare_at_price) : '');
      }
      if(variant.featured_image) {
        const image = main.querySelector('.product__media img');
        if(image) { image.src = variant.featured_image.src; image.removeAttribute('srcset'); }
      }
    };
    picker?.addEventListener('change', select);
    select();
    forms.forEach(form => bindAddForm(form, main, select));
  });
  document.querySelectorAll('form:not([data-al-product-form])').forEach(form => {
    if(form.closest('.jr-jewelry-page')) return;
    if(new URL(form.action, window.location.href).pathname === window.routes.cart_add_url) bindAddForm(form, form.closest('#MainContent') || document);
  });
  document.querySelectorAll('media-gallery').forEach(gallery => {
    gallery.querySelectorAll('[data-target]').forEach(button => button.addEventListener('click', () => {
      const media = document.getElementById(button.dataset.target);
      media?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
    }));
  });
});
if(!customElements.get('sticky-header')) {
  customElements.define('sticky-header', class extends HTMLElement {
    connectedCallback() {
      this.header = document.getElementById('shopify-section-amele-header');
      if(!this.header) return;
      this.lastScroll = window.scrollY;
      this.onScroll = () => {
        const position = window.scrollY;
        const focused = this.header.contains(document.activeElement);
        const open = this.header.querySelector('details[open], .amele-popup-overlay.is-visible');
        this.header.classList.toggle('al-header-hidden', position > this.header.offsetHeight && position > this.lastScroll && !focused && !open);
        this.lastScroll = position;
      };
      window.addEventListener('scroll',this.onScroll,{passive:true});
    }
    disconnectedCallback() { window.removeEventListener('scroll',this.onScroll); }
  });
}
